/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc PC端-更多服务-二维码图片
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/QR-code`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
